import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ProposalRepository } from '../infra/ProposalRepository'

export type DeleteLaneProposalFactoryDependencies = {
  repository: ProposalRepository
}

export type DeleteLaneProposalParams = {
  deleteParams: {
    laneProposalId: number
    rfpId: string
  }
  config: { signal: AbortSignal }
}

export function deleteLaneProposalFactory({ repository }: DeleteLaneProposalFactoryDependencies) {
  return function deleteLane({ deleteParams, config }: DeleteLaneProposalParams) {
    return repository.deleteLaneProposal(deleteParams, config)
  }
}

export function deleteLaneProposal(params: DeleteLaneProposalParams) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ProposalRepository({ httpClient })
  const deleteLane = deleteLaneProposalFactory({ repository })
  return deleteLane(params)
}
